import { useEffect, useState } from 'react';

const navItems = [
  { label: '首页', href: '#hero' },
  { label: '阅读功能', href: '#features' },
  { label: '分卷阅读', href: '#volumes' },
  { label: '追更指南', href: '#guide' },
  { label: '热门推荐', href: '#recommend' },
  { label: '常见问题', href: '#faq' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const solid = scrolled || open;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        solid ? 'bg-background-50/95 backdrop-blur shadow-[0_1px_0_0_rgba(0,0,0,0.06)]' : 'bg-transparent'
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 md:px-6 md:py-4">
        <a href="#hero" className="flex items-center gap-2" aria-label="漫蛙漫画首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-leaf-fill text-lg" aria-hidden="true"></i>
          </span>
          <span className="font-heading text-xl font-bold tracking-tight text-foreground-950">
            漫蛙漫画
          </span>
        </a>

        <nav className="hidden items-center gap-7 md:flex" aria-label="主导航">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="whitespace-nowrap text-sm font-medium text-foreground-700 transition-colors hover:text-primary-600"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#recommend"
            className="hidden whitespace-nowrap rounded-full bg-primary-500 px-5 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
          >
            开始追更
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-full border border-background-200 text-foreground-800 md:hidden"
            aria-label="打开菜单"
            aria-expanded={open}
          >
            <i className={`${open ? 'ri-close-line' : 'ri-menu-line'} text-xl`} aria-hidden="true"></i>
          </button>
        </div>
      </div>

      {open && (
        <nav className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 md:hidden" aria-label="移动端导航">
          <div className="flex flex-col">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="border-b border-background-100 py-3 text-sm font-medium text-foreground-800"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#recommend"
              onClick={() => setOpen(false)}
              className="mt-3 rounded-full bg-primary-500 px-5 py-2.5 text-center text-sm font-semibold text-background-50"
            >
              开始追更
            </a>
          </div>
        </nav>
      )}
    </header>
  );
}